import React, {useState} from "react";
import Modal from '../../component/Inc/Modal';
function PopAssignment(props) {
  const [modalOpenPolicy, setModalOpenPolicy] = useState(false);
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input pop_assignment" popSize="m">
			{/* 20250218 퍼블 추가 & 수정*/}
      {/* 정책 */}
      {modalOpenPolicy ? 
        <>
          <h2 className='pop_tit line'>원거리 배정 정책</h2>
          <div className="content_container scroll ">
            <div className="com_policy">
              <strong>2. 기준</strong>
              <em> 1) 정의</em>
              <p>(1) 원거리</p>
              <p className="in"> - 강사의 주수업 지역과 그 접한 지역을 제외한 지역으로 강사의 이동에 최소 편도 1시간 이상 소요되는 지역</p>
              <p>(2) 강사 부족지역</p>
              <p className="in">- 강사가 부족하여 배정이 어려운 지역</p>

              <em>2) 적용 기준</em>
              <p>(1) 일 시수 적용 강사</p>
              <p className="in">- 기존과 동일하게 2기 시수 적용</p>

              <p>(2) 45,000원 특별시수 적용 강사</p>
              <p className="in">- 원거리 배정 1~4타임은 시수 +3,000원 적용</p>
              <p className="in">- 원거리 배정 5타임부터 시수+5,000 적용</p>
              <p>※ 배정시점에 원거리배정 수업이 4타임 유지 상태여야 하며, 기안시 표기 필수</p>
              <p className="in">-중등 이하 수업의 배정은 상황을 종합적으로 고려하여 신중하게 적용</p>

              <em>3) 적용 방법</em>
              <p className="in">(1) 해당 시수 적용시 반드시 배정담당자가 기안 득한 후 적용</p>
              <p className="in">(2) 기안서 필수 기재 항목</p>
              <p className="in_depth2">① 적용시수</p>
              <p className="in_depth2">②강사부족지역 여부</p>
              <p className="in_depth2">③원거리 해당 여부</p>
              <p className="in_depth2">④원거리배정 상태</p>
            </div>
          </div>
					<hr className="com_divider"/>
          <div className="btn_container">
            <button className="com_btn orange xs" onClick={() => {setModalOpenPolicy(false)}}>확인</button>
          </div>
        </>
      : 
        <>
          <h2 className='pop_tit'>배정 보고서</h2>
          <div className="content_container scroll">
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont com_blue_txt"><b>홍길동103 </b> (고3ㆍ경기고등학교ㆍ본사) </span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont com_blue_txt">과탐(사회문화, 경제, 밥과정서)</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">회차 / 타임</span>
                  <span className="cont">16회 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">완성수업</span>
                  <span className="cont"></span>
                </div>
                <div className="info">
                  <span className="tit">수업 시간 / 방법</span>
                  <span className="cont">30분 / 대면</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">동시수업</span>
                  <span className="cont">김학생103, 최학생123, 최학생105</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">DC코드 / 할인금액</span>
                  <span className="cont">형제할인 5%ㆍ45,000</span>
                </div>
                <div className="info">
                  <span className="tit">1회 수업료</span>
                  <span className="cont">95,000</span>
                </div>
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont com_blue_txt">2,495,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업지역</span>
                  <span className="cont com_blue_txt">경기도 성남시 분당구 백형동 3214-345</span>
                </div>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">교사명</span>
                  <span className="cont">김교사102</span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <span className="cont">010-2020-0000</span>
                </div>
                <div className="info">
                  <span className="tit">거주지</span>
                  <span className="cont">경기도 용인시</span>
                </div>
                <div className="info">
                  <span className="tit">1순위 수업지역</span>
                  <span className="cont">경기도 용인시</span>
                </div>
                <div className="info">
                  <span className="tit">2순위 수업지역</span>
                  <span className="cont">경기도 용인시</span>
                </div>
                <div className="info">
                  <span className="tit">현재 시수</span>
                  <span className="cont com_blue_txt">특별시수ㆍ45,000</span>
                </div>
              </div>
            </div>
            <section className='com_board_list__top'>
              <select>
                <option>보고서 선택</option>
              </select>
              <button onClick={() => setModalOpenPolicy(true)} className="com_btn gray xs nowrap">원거리 배정 정책</button>
            </section>
            <table className='com_board_list type_row'>
              <colgroup>
                <col width="30%"/><col />
              </colgroup>
              <tbody>
                <tr>
                  <th>(4T) <br />원거리 배정 상황</th>
                  <td className="td_left">
                    원거리 배정 처음 <br />
                    김학생103ㆍ경기도 수원ㆍ2T l 수업중<br />
                    최학생405ㆍ경기도 은평구ㆍ1T l 수업 완료<br />
                    김학생103ㆍ경기도 수원ㆍ2T l 수업중
                  </td>
                </tr>
                <tr>
                  <th>원거리 시수</th>
                  <td className="td_left">
                    <div className="check">
                      {/*<input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                      <label htmlFor="rdo_01">2기 기수 적용</label>*/}
                      <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                      <label htmlFor="rdo_02">+ 3,000원 적용</label>
                      <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                      <label htmlFor="rdo_03">+ 5,000원 적용</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>배정담당 의견</th>
                  <td className="td_left">
                    
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
					
          <div className="btn_container">
            <button className="com_btn orange xs">등록</button>
          </div>
        </>
      }
    </Modal>
  );
}

export default PopAssignment;